import {BaseProps} from "../../../infrastructure/models/props/base-props";

import React from 'react';

export class TableHeaderProps extends BaseProps {
  className: String;
}

export const TableHeader = ({className, children, id, style}: TableHeaderProps) => {
  return (
    <th className={className} id={id} style={style}>
      {children}
    </th>
  )
}
